import { useState, useEffect, useContext, useRef } from "react";

import { TreeSelect } from "antd";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const UTreeSelect = ({ tree, ...props }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { dark, white, text, light, inputColors, gradients, transparent } = colors;
  return (
    <TreeSelect
      treeData={tree}
      fieldNames={{ label: "label", value: "id", children: "children" }}
      allowClear={true}
      size="large"
      placeholder="Select ..."
      style={{
        width: "100%",
      }}
      treeDefaultExpandAll={false}
      dropdownStyle={{
        maxHeight: 400,
        overflow: "auto",
        zIndex: 9999,
      }}
      treeLine={true}
      treeExpandedKeys={["10", "11", "12", "13", "14", "15"]}
      showArrow={true}
      suffixIcon={
        <ExpandMoreIcon
          sx={{
            fill: text.main,
            width: pxToRem(18),
            height: pxToRem(18),
            strokeWidth: 1,
            stroke: text.main,
            transform: dropdownOpen ? "rotate(180deg)" : "rotate(0)",
            transition: "transform 250ms ease",
          }}
        />
      }
      onDropdownVisibleChange={(open) => {
        setDropdownOpen(open);
      }}
      {...props}
    />
  );
};

export default UTreeSelect;
